import classNames from "classnames";

import {CloseIcon} from "@pg-design/icons-module";

import {useResponsiveModalContext} from "./ResponsiveModalContext";

import * as styles from "./ResponsiveModal.module.css";

export interface IResponsiveModalCloseButtonProps {
    ariaLabel?: string;
    className?: string;
    dataTestId?: string;
    onClick?: () => void;
}

export const ResponsiveModalCloseButton = (props: IResponsiveModalCloseButtonProps) => {
    const {ariaLabel = "Zamknij", className, dataTestId, onClick} = props;
    const {onClose} = useResponsiveModalContext();

    return (
        <button
            type="button"
            aria-label={ariaLabel}
            className={classNames(styles.closeButton, className)}
            onClick={() => (onClick ? onClick() : onClose())}
            data-testid={dataTestId}
        >
            <CloseIcon size="1.6" fill="var(--colors-secondary)" />
        </button>
    );
};
import classNames from "classnames";

import {CloseIcon} from "@pg-design/icons-module";

import {useResponsiveModalContext} from "./ResponsiveModalContext";

import * as styles from "./ResponsiveModal.module.css";

export interface IResponsiveModalCloseButtonProps {
    ariaLabel?: string;
    className?: string;
    dataTestId?: string;
    onClick?: () => void;
}

export const ResponsiveModalCloseButton = (props: IResponsiveModalCloseButtonProps) => {
    const {ariaLabel = "Zamknij", className, dataTestId, onClick} = props;
    const {onClose} = useResponsiveModalContext();

    return (
        <button
            type="button"
            aria-label={ariaLabel}
            className={classNames(styles.closeButton, className)}
            onClick={() => (onClick ? onClick() : onClose())}
            data-testid={dataTestId}
        >
            <CloseIcon size="1.6" fill="var(--colors-secondary)" />
        </button>
    );
};
